import { render, staticRenderFns } from "./Puesto.vue?vue&type=template&id=02192c95&scoped=true&"
import script from "./Puesto.vue?vue&type=script&lang=js&"
export * from "./Puesto.vue?vue&type=script&lang=js&"
import style0 from "./Puesto.vue?vue&type=style&index=0&id=02192c95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02192c95",
  null
  
)

export default component.exports